import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ResourceDto } from '@dto';
import { RequestMethodEnum, RequestOptions } from '@model';
import { GenericService } from './generic.service';

const RESOURCES_ENDPOINT = 'api/v1/resources';

@Injectable()
export class ResourceService {
  private _resources: ResourceDto[];
  get resources(): ResourceDto[] {
    return this._resources;
  }

  constructor(private resourceService: GenericService) {}

  resources$(): Observable<ResourceDto[]> {
    const options: RequestOptions<undefined, ResourceDto[]> = {
      method: RequestMethodEnum.GET,
      path: RESOURCES_ENDPOINT,
    };
    return this.resourceService.request(options).pipe(
      tap((entites: ResourceDto[]) => {
        this._resources = entites;
      }),
    );
  }
}
